import { type PropsWithChildren, createContext, useContext, useMemo } from 'react'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { IntegrationsPageStore } from 'pages/settings/pages/integrations/store/integrationsPageStore'

const IntegrationPageContext = createContext<IntegrationsPageStore | null>(null)

export const useIntegrationPageContext = () => {
  const context = useContext(IntegrationPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with IntegrationPageProvider')

  return context
}

export const IntegrationPageProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new IntegrationsPageStore(entities), [])

  return <IntegrationPageContext.Provider value={store}>{children}</IntegrationPageContext.Provider>
}
